module.exports = __webpack_public_path__ + "img/liechtenstein.c35c08a2.svg";